import React from 'react';
import { useNavigate } from 'react-router-dom';
import { internalRoutes } from '../config/routes'; // We'll define this in routes.ts
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import './DInternalPage.css';

const DInternalPage: React.FC = () => {

  const navigate = useNavigate();

  const handleInternalPage = (toPath: string) => {
    const fullPath = `/dinternal${toPath}`; // Construct the full path for navigation
    navigate(fullPath); // Use the full path
  };


  return (
    
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8 text-center text-primary">DInternal Tools</h1>
      <p className="text-center text-text-light mb-10">
        Welcome to the internal tools dashboard. Select a tool to get started.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {internalRoutes.map((route) => {
          let toPath = route.path;
          // Replace known parameters with default/sample values
          if (toPath.includes(':teamId')) {
            toPath = toPath.replace(':teamId', 'defaultTeam'); // Or your preferred default
          }
          if (toPath.includes(':issueId')) {
            toPath = toPath.replace(':issueId', 'defaultIssue'); // Or your preferred default
          }
          return (
            <button
              key={route.path}
              onClick={() => handleInternalPage(toPath)} // Pass the original internal route path (e.g., /csvanalysis)
              className="deriq-internal-action-card" // Ensure this class provides button-like styling or add base button styles
            >
              {route.icon && <FontAwesomeIcon icon={route.icon as IconProp} className="text-3xl mb-3 text-secondary" />}
              <h2 className="text-xl font-semibold text-color-light">{route.name}</h2>
              {route.description && <p className="text-sm mt-2">{route.description}</p>}
              {/* Optionally display the path for debugging, remove for production */}
              {/* <p className="text-xs text-gray-500 mt-1">{route.path}</p> */}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DInternalPage;